import { Component, Input } from '@angular/core'

@Component({
  selector: 'default-button-filled',
  standalone: true,
  imports: [],
  templateUrl: './default-button-filled.component.html',
})
export class DefaultButtonFilledComponent {
  @Input() text?: string
  @Input() color?: string
  @Input() disabled?: boolean
  @Input() click!: () => void
  @Input() type?: string
  @Input() className?: string
  @Input() width?: string = '100%'
  @Input() height?: string = '40px'
  @Input() fontSize?: string
  @Input() backgroundColor?: string

  hoverColor = 'bg-buttonFilledHover'

  constructor() {
    this.color = 'white'
    this.disabled = false
    this.type = 'button'
    this.className = ''
    this.fontSize = '14px'
    this.backgroundColor = 'bg-buttonFilledDefault'
  }

  onClickButton() {
    if (this.type === 'button') {
      if (typeof this.click === 'function') {
        this.click()
      }
    }
  }
}
